module.exports = __webpack_public_path__ + "static/media/percent.6af2f885.svg";